import styled from 'styled-components/native';
import {
  BorderProps,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  OpacityProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  ZIndexProps,
  border,
  color,
  flexbox,
  layout,
  opacity,
  position,
  shadow,
  space,
  zIndex,
} from 'styled-system';

export interface StyledPressableProps
  extends BorderProps,
    ColorProps,
    FlexboxProps,
    LayoutProps,
    OpacityProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    ZIndexProps {
  onHoverIn?: () => void;
  onHoverOut?: () => void;
  disabled?: boolean;
}

export const StyledPressable = styled.Pressable<StyledPressableProps>`
  ${border}
  ${color}
  ${flexbox}
  ${layout}
  ${opacity}
  ${position}
  ${shadow}
  ${space}
  ${zIndex}
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;
